import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import CTASection from './components/CTASection';
import WhatsAppButton from './components/WhatsAppButton';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/0507426ac8a76264b390c2066348759a/85882cb64467cd3b9d818993a97d20c4.jpeg" 
                alt="Adriana Muñoz Psicóloga" 
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h1 className={`text-lg font-semibold font-['Playfair_Display'] transition-colors ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}>
                  Adriana Muñoz
                </h1>
                <p className={`text-sm transition-colors ${
                  isScrolled ? 'text-gray-600' : 'text-white/90'
                }`}>
                  Psicóloga Profesional
                </p>
              </div>
            </div>
            <div className="hidden md:flex items-center gap-8">
              <a href="#servicios" className={`text-sm font-medium hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Servicios
              </a>
              <a href="#testimonios" className={`text-sm font-medium hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Testimonios
              </a>
              <a href="#contacto" className={`text-sm font-medium hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Contacto
              </a>
              <a 
                href="https://wa.me/526692612777?text=Hola%2C%20me%20gustaría%20agendar%20una%20consulta" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-[#14B8A6] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#0F9688] transition-colors whitespace-nowrap cursor-pointer"
              >
                Agendar Consulta
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <HeroSection />
      <ServicesSection />
      <CTASection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      
      {/* WhatsApp Floating Button */}
      <WhatsAppButton />
    </div>
  );
}
